import React, { useState } from "react";
import Card from "../../../Components/CardStucher";
import FormRenderer from "Common/Custom/FormRenderer";
import { Button, Badge } from "react-bootstrap";
import { PlusCircle, DashCircle, InfoCircle } from "react-bootstrap-icons";
import ParkingDetailsModal from "./ParkingDetailsModal";

const nowStamp = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

const ParkingBookingSection = ({
  values,
  setValues,
  errors,
  handleChange,
  parkingFields,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openCount = Number(values.current_vehicle || 0);

  const handleParkingChange = (e) => {
    handleChange(e);
    if (e.target.name === "is_parking" && e.target.value === "0") {
      setValues((prev) => ({
        ...prev,
        total_vehicle: 0,
        current_vehicle: 0,
        parking_movements: [],
      }));
    }
  };

  const addVehicle = () => {
    setValues((prev) => {
      const movements = [
        ...(prev.parking_movements || []),
        {
          Unic_key: crypto.randomUUID(),
          movement_type: "IN",
          vehicle_count: 1,
          movement_date: nowStamp(),
        },
      ];
      return {
        ...prev,
        parking_movements: movements,
        total_vehicle: Number(prev.total_vehicle || 0) + 1,
        current_vehicle: Number(prev.current_vehicle || 0) + 1,
      };
    });
  };

  const checkoutVehicle = () => {
    setValues((prev) => {
      const current = Number(prev.current_vehicle || 0);
      if (current <= 0) return prev;

      const movements = [...(prev.parking_movements || [])];
      const last = movements[movements.length - 1];

      // Only auto-undo if the absolute last action taken was an Add
      // (nothing recorded after it) — checks the array's actual tail,
      // not assuming sort order, since the API can return movements
      // in any order.
      if (last && last.movement_type === "IN" && Number(last.vehicle_count) === 1) {
        movements.pop();
        return {
          ...prev,
          parking_movements: movements,
          total_vehicle: Math.max(Number(prev.total_vehicle || 0) - 1, 0),
          current_vehicle: current - 1,
        };
      }

      movements.push({
        Unic_key: crypto.randomUUID(),
        movement_type: "OUT",
        vehicle_count: 1,
        movement_date: nowStamp(),
      });

      return {
        ...prev,
        parking_movements: movements,
        current_vehicle: current - 1,
        // total_vehicle is a lifetime counter — checkout does NOT reduce it
      };
    });
  };

  const fields = parkingFields.filter(
    (f) => f.name !== "total_vehicle" && f.name !== "vehicle_checkout"
  );

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const checkinDate = new Date(values.checkin_date);
  checkinDate.setHours(0, 0, 0, 0);

  const checkoutDate = new Date(values.checkout_date);
  checkoutDate.setHours(0, 0, 0, 0);

  const isTodayBetweenDates =
    today >= checkinDate && today <= checkoutDate;

  const is_direct_checkin = !isTodayBetweenDates ? 1 : 0;



  return (
    <Card
      heading={<h6 className="card-title">Parking Booking</h6>}
      CardHeaderClass="card-header"
      CardRowClass="row g-3"
      isRow={false}
    >
      <FormRenderer
        fields={fields.map((field) => ({
          ...field,
          ...(is_direct_checkin === 1 && { disabled: true })
        }))}
        values={values}
        errors={errors}
        handleChange={handleParkingChange}
      />

      {values.is_parking === "1" && (
        <div className="row mt-3">

          <div className="col-12 mb-3">
            <div className="border rounded p-3 bg-light">

              <div className="d-flex justify-content-between align-items-center">

                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-muted">
                    Currently Parked
                  </small>

                  <h4 className="mb-0 fw-bold text-primary ms-2">
                    {openCount}
                  </h4>
                </div>

                <Badge bg={openCount ? "success" : "secondary"}>
                  {openCount ? "Active" : "Empty"}
                </Badge>

              </div>

            </div>
          </div>

          <div className="col-6">
            <Button
              variant="success"
              className="w-100"
              onClick={addVehicle}
              disabled={is_direct_checkin === 1}
            >
              <PlusCircle className="me-2" />
              Add Vehicle
            </Button>
          </div>

          <div className="col-6">
            <Button
              variant="danger"
              className="w-100"
              disabled={!openCount || is_direct_checkin === 1}
              onClick={checkoutVehicle}
            >
              <DashCircle className="me-2" />
              Checkout
            </Button>
          </div>

          {values.parking_movements?.length > 0 && (
            <div className="col-12 mt-2">
              <Button
                variant="outline-primary"
                className="w-100"
                onClick={() => setShowModal(true)}
              >
                <InfoCircle className="me-2" />
                Parking History
              </Button>
            </div>
          )}

        </div>
      )}

      <ParkingDetailsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        movements={values.parking_movements}
        checkin_date={values.checkin_date}
        checkout_date={values.checkout_date}
        parking_price={values.parking_rate}
      />
    </Card>
  );
};

export default ParkingBookingSection;